import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@bcef/ia-components/header';
import { TranslatePipe } from '@ngx-translate/core';

import { ReportStore } from '@core/store/report.store';

import { BaseLayoutComponent } from './layout-base.component';

@Component({
  selector: 'ia-report-technical-problem-main-layout',
  imports: [HeaderComponent, TranslatePipe, RouterOutlet],
  template: `
    <ia-header
      [title]="'header.title' | translate"
      [steps]="'header.steps' | translate"
      [activeStepIndex]="store.currentStep()"
      [class]="headerClassAttributes"
    />
    <div
      class="tw-flex tw-flex-col mb-group:tw-mb-12 mb-group:tw-mt-5 mb-group:sm:tw-mt-10 md:mb-group:tw-mx-25"
    >
      <p
        class="tw-text-sm hbpro:tw-mb-6 hbpro:tw-text-payne-gray nhb:tw-mb-4 nhb:tw-mt-2 nhb:tw-text-hb-sm nhb:tw-text-slate-gray-2 mb-group:tw-mb-5 mb-group:max-md:tw-pl-4.5"
      >
        {{ 'screens.common.labels.mandatory' | translate }}
      </p>
      <router-outlet />
      <p class="tw-mt-5 tw-text-left tw-text-sm tw-font-normal tw-text-nevada max-sm:tw-px-5">
        {{ 'common.legalNotice' | translate }}
      </p>
    </div>
  `,
})
export class MainLayoutComponent extends BaseLayoutComponent {
  protected readonly store = inject(ReportStore);
}
